/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Transcript_Export_Timecode_Format_LabelInputs */

const en_transcript_export_timecode_format_label = /** @type {(inputs: Transcript_Export_Timecode_Format_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Timecode Format`)
};

const fr_transcript_export_timecode_format_label = /** @type {(inputs: Transcript_Export_Timecode_Format_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Format de timecode`)
};

const de_transcript_export_timecode_format_label = /** @type {(inputs: Transcript_Export_Timecode_Format_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Timecode-Format`)
};

const it_transcript_export_timecode_format_label = /** @type {(inputs: Transcript_Export_Timecode_Format_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formato del timecode`)
};

const ru_transcript_export_timecode_format_label = /** @type {(inputs: Transcript_Export_Timecode_Format_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Формат временного кода`)
};

const es_transcript_export_timecode_format_label = /** @type {(inputs: Transcript_Export_Timecode_Format_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formato de código de tiempo`)
};

const zh_cn2_transcript_export_timecode_format_label = /** @type {(inputs: Transcript_Export_Timecode_Format_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`时间码格式`)
};

const ja_transcript_export_timecode_format_label = /** @type {(inputs: Transcript_Export_Timecode_Format_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`タイムコード形式`)
};

const hi_transcript_export_timecode_format_label = /** @type {(inputs: Transcript_Export_Timecode_Format_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`टाइमकोड प्रारूप`)
};

const pt_pt2_transcript_export_timecode_format_label = /** @type {(inputs: Transcript_Export_Timecode_Format_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formato do código de tempo`)
};

/**
* | output |
* | --- |
* | "Timecode Format" |
*
* @param {Transcript_Export_Timecode_Format_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const transcript_export_timecode_format_label = /** @type {((inputs?: Transcript_Export_Timecode_Format_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Transcript_Export_Timecode_Format_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_transcript_export_timecode_format_label(inputs)
	if (locale === "de") return de_transcript_export_timecode_format_label(inputs)
	if (locale === "it") return it_transcript_export_timecode_format_label(inputs)
	if (locale === "ru") return ru_transcript_export_timecode_format_label(inputs)
	if (locale === "es") return es_transcript_export_timecode_format_label(inputs)
	if (locale === "zh-CN") return zh_cn2_transcript_export_timecode_format_label(inputs)
	if (locale === "ja") return ja_transcript_export_timecode_format_label(inputs)
	if (locale === "hi") return hi_transcript_export_timecode_format_label(inputs)
	if (locale === "pt-PT") return pt_pt2_transcript_export_timecode_format_label(inputs)
	return en_transcript_export_timecode_format_label(inputs)
});